import { Component } from "@angular/core";
import {LoadingController, NavParams} from "ionic-angular";
import {DomSanitizer} from "@angular/platform-browser";

@Component({
    templateUrl: 'habaHelpLink.html',
    selector: 'haba-help-link'
})

export class HabaHelpLink {
    private titleGame: string = '';
    private trustedUrl: any;
    private loading: any;

    constructor(private navParams: NavParams, public loadingCtrl: LoadingController, private sanitizer: DomSanitizer) {
        let getData = navParams.data;
        this.titleGame = getData.title;
        this.loading = loadingCtrl.create({content: ''});
        this.loading.present();
        this.trustedUrl = this.sanitizer.bypassSecurityTrustResourceUrl(getData.link);
    }

    webLoad(event) {
        this.loading.dismiss().catch(() => {});
    }
}


// WEBPACK FOOTER //
// ./src/pages/habaHelpLink/habaHelpLink.ts